// @flow
import createMessages from 'mz-intl/create'

const MESSAGES = {
  NO_ITEMS_FOUND: 'No items found for "{query}"',
  IM_SURE_VALUE_CORRECT_HEADER:
    'If you are sure that "{query}" is the correct value, then click below to confirm',
  IM_SURE_VALUE_CORRECT_BUTTON: 'Select "{query}"',
}

export default createMessages<typeof MESSAGES>(
  'UIKIT_FORM_SELECT_FIELD',
  MESSAGES
)
